<template>
  <div class="bpjs-page">
        <PageHeader icon="fas fa-shield-alt">
      <template #title>
        Pengaturan Integrasi BPJS
      </template>
      <template #subtitle>
        Kredensial disimpan terenkripsi dan tidak pernah ditampilkan kembali.
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-lg-8 mb-5">
        <div class="card card-custom gutter-b h-100">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column mb-0">
              <span class="card-label font-weight-bolder text-dark">Kredensial Web Service</span>
              <span class="text-muted mt-2 font-weight-bold font-size-sm">Silahkan masukkan Cons ID, Secret Key, dan User Key dari BPJS.</span>
            </h3>
          </div>
          <div class="card-body pt-0 pb-6">
            <div class="custom-alert custom-alert-warning mb-8">
              <div class="custom-alert-badge">
                <i class="fas fa-exclamation-triangle" style="font-size: 10px;"></i> Warning
              </div>
              <div class="custom-alert-icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 15px;">Kredensial Sensitif</span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 13px;">Gunakan kredensial resmi milik fasilitas kesehatan. Jangan membagikannya kepada pihak lain.</span>
              </div>
            </div>

            <b-form @submit.prevent="save">
              <b-form-group label="Consumer ID" label-class="font-weight-bolder">
                <b-form-input v-model.trim="form.cons_id" required autocomplete="off" class="form-control-solid form-control-lg" placeholder="Masukkan Consumer ID" />
              </b-form-group>
              
              <b-form-group label="Secret Key" label-class="font-weight-bolder">
                <div class="input-icon input-icon-right">
                  <b-form-input v-model="form.secret_key" :type="showSecret ? 'text' : 'password'" required autocomplete="new-password" class="form-control-solid form-control-lg" placeholder="Masukkan Secret Key" />
                  <span @click="showSecret = !showSecret" style="cursor: pointer; pointer-events: auto;">
                    <i :class="showSecret ? 'far fa-eye-slash' : 'far fa-eye'" class="text-muted"></i>
                  </span>
                </div>
              </b-form-group>
              
              <b-form-group label="User Key" label-class="font-weight-bolder">
                <div class="input-icon input-icon-right">
                  <b-form-input v-model="form.user_key" :type="showUserKey ? 'text' : 'password'" required autocomplete="new-password" class="form-control-solid form-control-lg" placeholder="Masukkan User Key" />
                  <span @click="showUserKey = !showUserKey" style="cursor: pointer; pointer-events: auto;">
                    <i :class="showUserKey ? 'far fa-eye-slash' : 'far fa-eye'" class="text-muted"></i>
                  </span>
                </div>
              </b-form-group>

              <div class="border-top pt-6 mt-7">
                <div class="d-flex align-items-start mb-5">
                  <div class="symbol symbol-35 symbol-light-info mr-3 flex-shrink-0">
                    <span class="symbol-label"><i class="fas fa-clinic-medical text-info"></i></span>
                  </div>
                  <div>
                    <div class="font-weight-bolder text-dark">Kredensial Khusus PCare</div>
                    <div class="text-muted font-size-sm">
                      Opsional. Isi ketiganya jika paket credential BPJS klinik menyertakan akun PCare.
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group label="Username PCare" label-class="font-weight-bolder">
                      <b-form-input
                        v-model.trim="form.pcare_username"
                        autocomplete="off"
                        class="form-control-solid"
                        placeholder="Username PCare"
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group label="Application Code" label-class="font-weight-bolder">
                      <b-form-input
                        v-model.trim="form.pcare_app_code"
                        autocomplete="off"
                        class="form-control-solid"
                        placeholder="Application Code"
                      />
                    </b-form-group>
                  </div>
                </div>

                <b-form-group label="Password PCare" label-class="font-weight-bolder">
                  <div class="input-icon input-icon-right">
                    <b-form-input
                      v-model="form.pcare_password"
                      :type="showPcarePassword ? 'text' : 'password'"
                      autocomplete="new-password"
                      class="form-control-solid"
                      placeholder="Password PCare"
                    />
                    <span @click="showPcarePassword = !showPcarePassword" style="cursor: pointer; pointer-events: auto;">
                      <i :class="showPcarePassword ? 'far fa-eye-slash' : 'far fa-eye'" class="text-muted"></i>
                    </span>
                  </div>
                </b-form-group>
              </div>
              
              <div class="d-flex flex-column flex-sm-row justify-content-between mt-8">
                <b-button v-if="configured" variant="light-danger" class="mb-3 mb-sm-0 font-weight-bold px-6" @click="remove">
                  <i class="far fa-trash-alt mr-2"></i>Putuskan Integrasi
                </b-button>
                <span v-else></span>
                <b-button type="submit" variant="primary" :disabled="saving" class="font-weight-bold px-8">
                  <b-spinner v-if="saving" small class="mr-2" /><i v-else class="fas fa-save mr-2"></i>Simpan Kredensial
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
      
      <div class="col-lg-4 mb-5">
        <div class="card card-custom gutter-b h-100 bg-light-primary border-0">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column mb-0">
              <span class="card-label font-weight-bolder text-dark">Status Koneksi</span>
            </h3>
          </div>
          <div class="card-body pt-0">
            <div 
              class="custom-alert mb-8"
              :class="configured ? 'custom-alert-success' : 'custom-alert-danger'"
            >
              <div class="custom-alert-badge">
                <i class="fas" :class="configured ? 'fa-check-circle' : 'fa-times-circle'" style="font-size: 11px;"></i>
                {{ configured ? "Terhubung" : "Belum Terhubung" }}
              </div>
              <div class="custom-alert-icon">
                <i class="fas" :class="configured ? 'fa-link' : 'fa-unlink'"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 15px;">
                  {{ configured ? "Integrasi Aktif" : "Menunggu Konfigurasi" }}
                </span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 13px; line-height: 1.4;">
                  {{ statusMessage }}
                </span>
              </div>
            </div>

            <div class="custom-alert custom-alert-info mb-6">
              <div class="custom-alert-badge">
                <i class="fas fa-server" style="font-size: 10px;"></i> Infrastruktur
              </div>
              <div class="custom-alert-icon">
                <i class="fas fa-database"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 14px;">Terisolasi</span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 13px;">Database terpisah per klinik</span>
              </div>
            </div>

            <div class="custom-alert custom-alert-warning mb-6">
              <div class="custom-alert-badge">
                <i class="fas fa-shield-alt" style="font-size: 10px;"></i> Keamanan
              </div>
              <div class="custom-alert-icon">
                <i class="fas fa-lock"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 14px;">Terenkripsi</span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 13px;">Aman dengan standar enkripsi AES</span>
              </div>
            </div>

            <div class="custom-alert custom-alert-secondary mb-2" style="margin-top: 0;">
              <div class="custom-alert-icon">
                <i class="fas fa-user-secret"></i>
              </div>
              <div class="d-flex flex-column">
                <span class="font-weight-bolder text-dark mb-1" style="font-size: 14px;">Terjaga</span>
                <span class="text-dark-75 font-weight-bold" style="font-size: 13px;">Kredensial tidak tampil di browser</span>
              </div>
            </div>

            <div class="reference-sync mt-5">
              <div class="font-weight-bolder text-dark mb-1">Referensi BPJS</div>
              <div class="text-muted font-size-sm mb-3">
                Perbarui kode dokter dan kode poli agar form kunjungan dapat memakai lookup.
              </div>
              <b-button
                variant="outline-primary"
                block
                :disabled="!configured || syncing"
                @click="syncReferences"
              >
                <b-spinner v-if="syncing" small class="mr-2" />
                <i v-else class="fas fa-sync-alt mr-2"></i>
                Sinkronkan data BPJS
              </b-button>
              <small v-if="lastSyncMessage" class="d-block mt-2 text-muted">
                {{ lastSyncMessage }}
              </small>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { errorMessage } from "./bpjs.helpers";

export default {
  data: () => ({
    configured: false,
    statusMessage: "Memeriksa konfigurasi...",
    saving: false,
    syncing: false,
    lastSyncMessage: "",
    showSecret: false,
    showUserKey: false,
    showPcarePassword: false,
    form: {
      cons_id: "",
      secret_key: "",
      user_key: "",
      pcare_username: "",
      pcare_password: "",
      pcare_app_code: "",
    },
  }),
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "BPJS Kesehatan" }, { title: "Pengaturan Integrasi" }]);
    this.load();
  },
  methods: {
    async load() {
      try {
        const response = await ApiService.get("bpjs/settings");
        if (response.status >= 400) throw response;
        const data = response.data || {};
        this.configured = Boolean(data.is_configured);
        this.statusMessage = data.message || "Status konfigurasi berhasil diperiksa.";
      } catch (error) {
        this.statusMessage = errorMessage(error, "Status belum dapat diperiksa.");
      }
    },
    async save() {
      this.saving = true;
      try {
        const response = await ApiService.post("bpjs/settings", this.form);
        this.$bvToast.toast(response.data.message || "Kredensial berhasil disimpan.", { title: "Berhasil", variant: "success", solid: true });
        this.form = {
          cons_id: "",
          secret_key: "",
          user_key: "",
          pcare_username: "",
          pcare_password: "",
          pcare_app_code: "",
        };
        await this.load();
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), { title: "Gagal menyimpan", variant: "danger", solid: true });
      } finally { this.saving = false; }
    },
    async remove() {
      const confirmed = await this.$bvModal.msgBoxConfirm("Putuskan integrasi dan hapus kredensial BPJS klinik ini?", {
        title: "Putuskan integrasi", okTitle: "Ya, putuskan", cancelTitle: "Batal", okVariant: "danger",
      });
      if (!confirmed) return;
      try {
        await ApiService.delete("bpjs/settings");
        this.configured = false;
        this.statusMessage = "Credential BPJS belum dikonfigurasi.";
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), { title: "Gagal", variant: "danger", solid: true });
      }
    },
    async syncReferences() {
      this.syncing = true;
      try {
        const response = await ApiService.post("bpjs/references/sync", {});
        const data = response.data || {};
        const synced = data.synced || {};
        this.lastSyncMessage = `${synced.doctors || 0} dokter · ${synced.polyclinics || 0} poli`;
        this.$bvToast.toast(
          data.message || "Referensi BPJS berhasil diperbarui.",
          { title: "Sinkronisasi selesai", variant: "success", solid: true }
        );
      } catch (error) {
        this.$bvToast.toast(errorMessage(error), {
          title: "Sinkronisasi gagal",
          variant: "danger",
          solid: true,
        });
      } finally {
        this.syncing = false;
      }
    },
  },
};
</script>

<style scoped>
.custom-alert {
  position: relative;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  margin-top: 16px;
}
.bpjs-page ::v-deep .form-group {
  margin-bottom: 0.75rem;
}
.bpjs-page ::v-deep .form-control-lg {
  height: 40px;
  font-size: 0.9rem;
}
.reference-sync {
  padding: 14px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dfe8e6;
}
.custom-alert-warning {
  background-color: #FFFBEB;
  border-color: #FDE68A;
}
.custom-alert-badge {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.custom-alert-warning .custom-alert-badge {
  background-color: #F59E0B;
  color: white;
}
.custom-alert-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  margin-right: 16px;
}
.custom-alert-icon i,
.custom-alert-badge i {
  color: inherit !important;
}
.custom-alert-warning .custom-alert-icon {
  background-color: rgba(245, 158, 11, 0.15);
  color: #F59E0B;
  border: 1px solid rgba(245, 158, 11, 0.3);
}
.custom-alert-success {
  background-color: #ECFDF5;
  border-color: #A7F3D0;
}
.custom-alert-success .custom-alert-badge {
  background-color: #10B981;
  color: white;
}
.custom-alert-success .custom-alert-icon {
  background-color: rgba(16, 185, 129, 0.15);
  color: #10B981;
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.custom-alert-danger {
  background-color: #FEF2F2;
  border-color: #FECACA;
}
.custom-alert-danger .custom-alert-badge {
  background-color: #EF4444;
  color: white;
}
.custom-alert-danger .custom-alert-icon {
  background-color: rgba(239, 68, 68, 0.15);
  color: #EF4444;
  border: 1px solid rgba(239, 68, 68, 0.3);
}
.custom-alert-info {
  background-color: #F0F9FF;
  border-color: #BAE6FD;
}
.custom-alert-info .custom-alert-badge {
  background-color: #0EA5E9;
  color: white;
}
.custom-alert-info .custom-alert-icon {
  background-color: rgba(14, 165, 233, 0.15);
  color: #0EA5E9;
  border: 1px solid rgba(14, 165, 233, 0.3);
}
.custom-alert-secondary {
  background-color: #F3F4F6;
  border-color: #E5E7EB;
}
.custom-alert-secondary .custom-alert-icon {
  background-color: #E5E7EB;
  color: #4B5563;
  border: 1px solid #D1D5DB;
}
</style>
